import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=864e0d20&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=864e0d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864e0d20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('864e0d20')) {
      api.createRecord('864e0d20', component.options)
    } else {
      api.reload('864e0d20', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=864e0d20&scoped=true&", function () {
      api.rerender('864e0d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MemoDeal/Profile.vue"
export default component.exports